import React from "react";
import { connect } from "react-redux";
import {
  actions as uiLibraryActions,
  selectors as uiLibrarySelectors
} from "../../../../redux/ui/library";
import Panel from "../../../components/panel";
import BookPanel from "../book/panel";
import SearchPanel from "../search/panel";
import SimpleBookPanel from "../book/simplepanel";
import MobileLibSearchPanel from "../header/search/index";

const panelContent = panel => {
  switch (panel.type) {
    case "book":
      return <BookPanel isbn={panel.data.isbn} />;
    case "search":
      return <SearchPanel />;
    case "simplebook":
      return <SimpleBookPanel isbn={panel.data.isbn} />;
    case "mobile-search":
      return <MobileLibSearchPanel title="results" />;
    default:
      return null;
  }
};

const ConnectedPanel = ({ closePanel, isPanelOpen, panel }) => {
  if (isPanelOpen) {
    return (
      <Panel
        open={isPanelOpen}
        title={panel.data.title}
        onRequestClose={closePanel}
        removeCloseButton={panel.type === "mobile-search"}
      >
        {panelContent(panel)}
      </Panel>
    );
  }
  return null;
};

const mapStateToProps = (state, props) => ({
  isPanelOpen: uiLibrarySelectors.isPanelOpen(state),
  panel: uiLibrarySelectors.getPanel(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  closePanel: () => dispatch(uiLibraryActions.closePanel())
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedPanel);
